import { logDebug } from 'middleware/logger';
import AppEnvironment from 'helpers/AppEnvironment';
import { recordToSplunk } from 'apis/recordToSplunk';

export interface ZfcEventData {
  type: string;
  payload?: unknown;
}

export const MAX_EVENTS_PER_BATCH = 5;
export const DEBOUNCE_MS = 1000;

let eventQueue: ZfcEventData[] = [];
let debounceTimer: ReturnType<typeof setTimeout> | null = null;

export const flush = () => {
  if (!eventQueue.length) {
    return;
  }
  const batch = eventQueue;
  eventQueue = [];
  if (debounceTimer) {
    clearTimeout(debounceTimer);
    debounceTimer = null;
  }
  recordToSplunk(`type=zfc-event&data=${encodeURIComponent(JSON.stringify(batch))}`);
};

export const scheduleFlush = () => {
  if (debounceTimer) {
    clearTimeout(debounceTimer);
  }
  if (eventQueue.length >= MAX_EVENTS_PER_BATCH) {
    flush();
    return;
  }
  debounceTimer = setTimeout(flush, DEBOUNCE_MS);
};

// flush remaining events on page unload, same as Titanite's beforeunload handler
if (AppEnvironment.isClient) {
  window.addEventListener('beforeunload', flush);
}

const zfcEventLog = (event: ZfcEventData | string) => {
  logDebug('zfc-event', event);
  if (AppEnvironment.isClient) {
    const entry: ZfcEventData = typeof event === 'string' ? { type: event } : event;
    eventQueue.push(entry);
    scheduleFlush();
  }
};

// exposed for testing
export const _getQueue = () => eventQueue;
export const _resetQueue = () => {
  eventQueue = [];
  if (debounceTimer) {
    clearTimeout(debounceTimer);
    debounceTimer = null;
  }
};

export default zfcEventLog;
